import { render, staticRenderFns } from "./ProductSelectedItem.vue?vue&type=template&id=59291f50&scoped=true"
import script from "./ProductSelectedItem.vue?vue&type=script&lang=js"
export * from "./ProductSelectedItem.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectedItem.vue?vue&type=style&index=0&id=59291f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59291f50",
  null
  
)

export default component.exports